import React from "react";
import CustomNavbar from "../components/Navbar/Navbar";
import HeroSection from "../components/Hero-Section/Hero";
import QueryForm from "../components/Query-form/QueryForm";
import DoctorProfile from "../components/Doctor-info/DoctorProfile";
import DiscountService from "../components/DiscountAndService/DiscountService";
import WhyChooseUs from "../components/WhyChooseUs-Section/WhyChooseUs";
import GoogleReviews from "../components/Reviews/GoogleReview";
import ContactRow from "../components/Query-form/ContactRow";
import Footer from "../components/Footer/Footer";




function Home() {
  return (
    <>
    <CustomNavbar />
    <HeroSection />
    <QueryForm />
    <DoctorProfile/>
    {/* <TreatmentsCarousel/> */}
    <DiscountService/>
    <WhyChooseUs/>
    <GoogleReviews/>
    <ContactRow/>
    <Footer/>
    </>
    
  );
}

export default Home;
